import { GiSuitcase } from "react-icons/gi";
import colors from "core/resources/theme/colors";
import DashboardCard from "ui/components/Cards/DashboardCard";
import { useTotalDespesas } from "core/features/dashboards/hooks/useTotalDespesas";
import { useDashboardPrincipal } from "core/features/dashboards/store";
import { formatMoney } from "infra/helpers/number";

function CardTempoContrato() {
  const { query } = useDashboardPrincipal();
  const { data, isFetching } = useTotalDespesas(query);

  return (
    <DashboardCard
      isLoading={isFetching}
      positive={true}
      bg={colors.lightGray}
      label="Tempo de Contrato"
      valuePercent={null}
      value={formatMoney(data?.total ?? 0)}
      icon={<GiSuitcase fontSize="32px" color={colors.darkGray} />}
    />
  );
}

export default CardTempoContrato;
